module.exports = __webpack_public_path__ + "VIPC8.png?0c9689ae9bcf1107123dffa8fe3f1223";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/cycling/VIPC8.png
// module id = 71
// module chunks = 0